import { render, staticRenderFns } from "./StudyLoginPage.vue?vue&type=template&id=261f9fef&scoped=true&"
import script from "./StudyLoginPage.vue?vue&type=script&lang=ts&"
export * from "./StudyLoginPage.vue?vue&type=script&lang=ts&"
import style0 from "./StudyLoginPage.vue?vue&type=style&index=0&id=261f9fef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f9fef",
  null
  
)

export default component.exports